// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"187":"cityCompany","536":"myAbout","640":"storeEnter","881":"newAsync"}[chunkId] + "." + {"187":"cfc712ab","536":"4fa32676","640":"63b4c49e","881":"902ea7a4"}[chunkId] + ".css";
};